export default class ProposalPriceAfterAdjustmentCalculationError extends Error {
    constructor(message: string) {
        super(message);
        Object.setPrototypeOf(this, ProposalPriceAfterAdjustmentCalculationError.prototype);
    }
}
